module.exports = __webpack_public_path__ + "img/bb-arrow-icon.8fe55c97.svg";